import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=2ebfe856&scoped=true&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=2ebfe856&prod&lang=sass&scoped=true&"
import style1 from "./FormEdit.vue?vue&type=style&index=1&id=2ebfe856&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfe856",
  null
  
)

export default component.exports